<div class="shopping-cart-container">
  @if (checkIfCartNotEmpty()) {
    <button
      style="background: linear-gradient(135deg, #22c55e, #16a34a) !important"
      class="checkout-button"
      data-theme-key="--checkout-green"
      [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
      (click)="checkOut()">
      <div class="checkout-content">
        Check Out&nbsp;
        <img class="cart-icon" src="assets/svg/shopping-cart.svg" alt="Shopping Cart" />

        <span class="cart-count-badge" data-theme-key="--ribbon-bg">
          {{ getNumberOfOffersInShoppingCart() }}
        </span>
      </div>
    </button>
  }
</div>
